// O valor de um campo customizado numa linha da listagem de chamados.
//
// ## Por que isto é um util, e não três linhas dentro da tela
//
// Era `params.row.fields.find(...)`, sem guarda. A lista de chamados é
// alimentada por DUAS fontes:
//
//   - `/ticket` (a lista de ativos, em memória) traz a relação `fields`;
//   - `/ticket/paginated` (ordenação, busca no servidor, finalizados sob
//     demanda) NÃO trazia.
//
// Medido em produção em 27/10/2026, no filtro "Meus tikets não resolvidos"
// (que tem uma coluna de campo customizado): clicar em "Data de abertura"
// para ordenar derrubava a TELA INTEIRA -- `#root` vazio, fundo branco, e
// nada de erro para o operador. `TypeError: Cannot read properties of
// undefined (reading 'find')`, dentro do `renderCell`. Era o relato de que
// "ordenar por data deixa a tela em branco" (Gisele, ponto 3).
//
// Uma célula sem o dado não pode derrubar a página. O endpoint paginado
// passou a mandar `fields` também, mas a guarda fica: é ela que garante que
// a próxima fonte a esquecer uma relação apareça como "Sem valor" numa
// coluna, e não como tela branca.

/** O que mostrar quando o chamado não tem esse campo preenchido. */
export const SEM_VALOR = 'Sem valor';

/**
 * @param {object} chamado linha de chamado como a listagem a recebe
 * @param {number|string} idDoCampo `id` do campo customizado
 * @returns {*} o valor gravado, ou `SEM_VALOR` quando o campo não está na linha
 */
export function valorDoCampoCustomizado(chamado, idDoCampo) {
    const todos = Array.isArray(chamado?.fields) ? chamado.fields : [];
    const campo = todos.find((f) => f?.field_id === idDoCampo);

    return campo ? campo.value : SEM_VALOR;
}

export default valorDoCampoCustomizado;
